(function () {
    'use strict';

    angular
        .module('tikonApp')
        .provider('AlertService', AlertService);

    function AlertService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function (isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate', 'AlertToastService'];

        function getService($timeout, $sce, $translate, AlertToastService) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 8000; // default timeout


            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning: warning,
                showHelpMessage: help,
                showValidationMessage: validationMessage
            };

            function validationMessage(element, message, theme, timer, openAction) {
                if (!openAction) openAction = 'custom';
                if (!theme) theme = 'tooltipster-error';
                if (!timer) timer = 5000;
                var elementid = $(element).attr('id');

                destroyAllTooltips();
                if (message) {
                    var messageId = message.split('.').join('');
                    var tooltipClass = elementid + messageId + '-tooltip';
                    var tooltipContentId = elementid + messageId + '-tooltip-content';
                    addValidationMessage();
                }


                function getTooltipInstance() {
                    var instances = $.tooltipster.instances(element);
                    var rightInstance = instances[0];
                    angular.forEach(instances, function (ins) {
                        //
                        if (!ins.status().destroyed && !ins.status().destroying && ins.content()[0].id == tooltipContentId)
                            rightInstance = ins
                    });
                    return rightInstance;

                }

                function destroyAllTooltips() {
                    //
                    var instances = $.tooltipster.instances(element);
                    for (var i = 0; i < instances.length; i++) {
                        instances[i].destroy();
                    }


                }

                function addValidationMessage() {
                    //
                    $translate(message).then(function (m) {

                        message = m;
                        makeTooltip();
                    }, function (translationId) {
                        //   console.log('translation not found for :' + message);
                        //   destroyAllTooltips();
                        makeTooltip();
                    });
                }

                function makeTooltip() {
                    var errorMessage =
                        $('<div class="validation-message-container" >' +

                            '<div class="' + tooltipClass + '" id="' + tooltipContentId + '" ><span >' + message + '</span></div>' +
                            '</div>');

                    $(element).addClass(tooltipClass);

                    errorMessage.insertAfter($(element));
                    $(element).attr('data-tooltip-content', '#' + tooltipContentId);
                    var side = getSide();

                    $(element).tooltipster({
                        theme: theme,
                        side: side,
                        trigger: openAction,
                        triggerOpen: {},
                        triggerClose: ['click', 'originClick', 'tap'],
                        timer: timer,
                        multiple: true,
                        contentCloning: true,
                        animation: 'grow',
                        arrow: true,
                        contentAsHTML: true,
                        maxWidth: 500,
                        minWidth: 200,

                        animationDuration: [500, 1000],
                        functionBefore: beforeOpen,
                        viewportAware: false,


                    });
                    getTooltipInstance().open();


                }

                function beforeOpen(tooltip) {
                    //if left of tooltip==0
                    //so it is in wrong place
                    //and shoulb be stopped!
                    return (tooltip.__geometry().origin.offset.left > 0);
                }

                //this method return the tooltip side based on the available tooltip instance on
                //current element
                function getSide() {
                    return ['left', 'bottom'];

                    //var allSides = [ 'bottom','left', 'top', 'right'];
                    //var instancesCount = $.tooltipster.instances(element).length;
                    //if (instancesCount > 3)instancesCount = 0;
                    //return allSides[instancesCount];

                }
            }

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }


            function success(msg, params, position) {


                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {

                AlertToastService.error(msg, params, position);
                //
                // return this.add({
                //     type: 'danger',
                //     msg: msg,
                //     params: params,
                //     timeout: timeout,
                //     toast: toast,
                //     position: position
                // });
            }

            function warning(msg, params, position) {

                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {

                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function help(element, msg, params, position) {
                validationMessage(element, msg, 'tooltipster-light', 30000, 'click');
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'bottom right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if (!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {

                alertOptions.alertId = alertId++;
                var mes = alertOptions.msg;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                if (alertOptions.msg == mes) {
                    //console.log(mes);
                    return;
                    //   alertOptions.msg="پیغام های خطا را بررسی کنید";
                }
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function (e) {
                    return e.id;
                }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
